/* @flow */
import * as React from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import RankingPage from '../../common/RankingPage';

type Props = {
  goBack: Function,
};

function SushiRankingPage(props: Props) {
  const { goBack } = props;
  return <RankingPage kind="sushi" onNextClick={goBack} />;
}

const dispatchToProps = dispatch => ({
  goBack: () => dispatch(push('/sushi/fields?skip_intro=1')),
});

const SushiRankingPageContainer = connect<Props, {||}, _, _, _, _>(null, dispatchToProps)(SushiRankingPage);
export default SushiRankingPageContainer;
